import { JACKPOT_MODULE_NAMES, VOUCHER_MODULE_NAMES } from "src/app/core/constants/enums";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createFeatureSelector, createReducer, createSelector, on, select } from "@ngrx/store";
import {
    STATUS_BAR_MODULE_SELECTED,
    FREE_TO_PLAY_MODULE_SELECTED,
    FILTER_VOUCHERS_BY_CATEGORY,
    VOUCHERS_MODULE_SELECTED,
    BETTING_TASKS_MODULE_SELECTED,
    BETTING_TAB_SELECTED,
    DISABLE_TASK_BAR_BUTTON_NAVIGATION,
    JACKPOT_MODULE_SELECTED
} from "../actions/button-click.actions";

import { BETTING_TASKS_MODULES, FREE_TO_PLAY_MODULE_NAMES, VOUCHER_CATEGORIES } from "src/app/core/constants/enums";
import { ButtonsState } from "../buttons-state";
import { ROUTES } from "src/app/core/constants/routes";

const getButtonsFeatureState = createFeatureSelector<ButtonsState>("buttons");

export const selectModuleName = createSelector(
    selectSelectedModule,
    state => state
);

export const selectedBettingTab = createSelector(
    selectBettingTab,
    state => state
);

export const selectVouchersModuleName = createSelector(
    selectVouchersModule,
    state => state
);

export const selectFreeToPlayModuleName = createSelector(
    selectFreeToPlayModule,
    state => state
);

export const selectJackpotModuleName = createSelector(
    selectJackpotFilter,
    state => state
);

export const selectVouchersFilterName = createSelector(
    selectVouchersFilter,
    state => state
);

export const selectedBettingTasksFilterName = createSelector(
    selectBettingTasksFilter,
    state => state
);

export const isNavigationDisabled = createSelector(
    getButtonsFeatureState,
    (buttonsState: ButtonsState) => buttonsState && buttonsState.isNavigationDisabled
);

const initialState: ButtonsState = {
    taskBarButton: "",
    isNavigationDisabled: false
};

export const buttonsReducer = createReducer<ButtonsState>(
    initialState,
    on(STATUS_BAR_MODULE_SELECTED, (state: ButtonsState, { button }): ButtonsState => {
        sessionStorage.setItem("selectedModule", button);
        return {
            ...state
        };
    }),
    on(FILTER_VOUCHERS_BY_CATEGORY, (state: ButtonsState, { categoryName }): ButtonsState => {
        sessionStorage.setItem("selectedVoucherFilter", categoryName);
        return {
            ...state
        };
    }),
    on(VOUCHERS_MODULE_SELECTED, (state: ButtonsState, { button }): ButtonsState => {
        sessionStorage.setItem("selectedVouchersModule", button);
        return {
            ...state
        };
    }),
    on(FREE_TO_PLAY_MODULE_SELECTED, (state: ButtonsState, { button }): ButtonsState => {
        sessionStorage.setItem("selectedFreeToPlayModule", button);
        return {
            ...state
        };
    }),
    on(BETTING_TASKS_MODULE_SELECTED, (state: ButtonsState, { button }): ButtonsState => {
        sessionStorage.setItem("selectedBettingTasksFilter", button);
        return {
            ...state
        };
    }),
    on(BETTING_TAB_SELECTED, (state: ButtonsState, { button }): ButtonsState => {
        sessionStorage.setItem("selectedBettingTab", button);
        return {
            ...state
        };
    }),
    on(JACKPOT_MODULE_SELECTED, (state: ButtonsState, { button }): ButtonsState => {
        sessionStorage.setItem("selectedJackpotModule", button);
        return {
            ...state
        };
    }),
    on(DISABLE_TASK_BAR_BUTTON_NAVIGATION, (state: ButtonsState, { isNavigationDisabled }): ButtonsState => {
        return {
            ...state,
            isNavigationDisabled: isNavigationDisabled
        };
    }),
);

function selectSelectedModule(): string {
    const selectedModule = sessionStorage.getItem("selectedModule")! as string;
    return selectedModule === "undefined" || selectedModule == null ? ROUTES.HOME_BETTING : selectedModule;
}

function selectBettingTab(): string {
    const selectedModule = sessionStorage.getItem("selectedBettingTab")!;
    return selectedModule === "undefined" || selectedModule == null ? ROUTES.BETTING_TASKS : selectedModule;
}

function selectVouchersModule(): string {
    const selectedModule = sessionStorage.getItem("selectedVouchersModule")!;
    return selectedModule === "undefined" || selectedModule == null ? VOUCHER_MODULE_NAMES.VOUCHERS : selectedModule;
}

function selectFreeToPlayModule(): string {
    const selectedModule = sessionStorage.getItem("selectedFreeToPlayModule")!;
    return selectedModule === "undefined" || selectedModule == null ? FREE_TO_PLAY_MODULE_NAMES.ACTIVE_TICKETS : selectedModule;
}

function selectVouchersFilter(): string {
    const selectedFilter = sessionStorage.getItem("selectedVoucherFilter")!;
    return selectedFilter === "undefined" || selectedFilter == null ? VOUCHER_CATEGORIES.BETTING : selectedFilter;
}

function selectBettingTasksFilter(): string {
    const selectedFilter = sessionStorage.getItem("selectedBettingTasksFilter")!;
    return selectedFilter === "undefined" || selectedFilter == null ? BETTING_TASKS_MODULES.IN_PROGRESS : selectedFilter;
}

function selectJackpotFilter(): string {
    const selectedModule = sessionStorage.getItem("selectedJackpotModule")!;
    return selectedModule === "undefined" || selectedModule == null ? JACKPOT_MODULE_NAMES.LOCAL : selectedModule;
}
